// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import { NavigationDropDown } from '../NavigationDropDown';

export type Props = {
  className?: string,
};

export function LegalLinks({ className }: Props): React.MixedElement {
  const { __ } = useTranslator();

  const items = [
    {
      title: __("ICANN's Registrant Educational Rights"),
      href: __(
        'https://www.icann.org/en/resources/registrars/registrant-rights/educational',
      ),
    },
    {
      title: __('ICANN Registrant Rights'),
      href: __(
        'https://www.icann.org/en/resources/registrars/registrant-rights/benefits/',
      ),
    },
  ];

  return (
    <NavigationDropDown
      id="layout-legal-selector"
      placement="bottom"
      navigationItems={items}
      label={__('legal')}
      className={className}
    />
  );
}
